// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a085443d","239":"11ab217b","453":"0e8b1ee0","455":"61fa81e8","557":"9d0385a3","762":"15ef4c44"}[chunkId] + ".chunk.js";
};